import { User } from "src/features/users/types/user.entity";

type Props = {
  user: User;
};

export const RefundUserInfo = ({ user }: Props) => {
  return (
    <div className="flex items-center gap-4 border border-gray-100 rounded-lg p-4 mb-5 bg-gray-50">
      <div className="w-12 h-12 rounded-full bg-gray-300 flex items-center justify-center text-white text-lg font-medium uppercase">
        {user?.pictureURL ? (
          <img src={user.pictureURL} alt="User Avatar" className="w-12 h-12 rounded-full object-cover" />
        ) : (
          user.name?.charAt(0) || "U"
        )}
      </div>

      <div className="flex-1">
        <p className="font-semibold text-gray-800 text-base">{user.name || "Unknown User"}</p>
        <p className="text-sm text-gray-500">{user.email || "No email"}</p>
      </div>

      <span className="text-xs font-medium bg-blue-100 text-blue-700 px-2 py-1 rounded-full">
        {user.roles.includes("COACH") ? "Dual" : "Learner"}
      </span>
    </div>
  );
};
